export const filterChips = [
  { label: 'All', active: true },
  { label: 'Music', active: false },
  { label: 'Folk', active: false },
  { label: 'Bass / DnB', active: false },
  { label: 'Market', active: false },
  { label: 'Community', active: false },
  { label: 'Spoken Word', active: false },
] as const
